module.exports = __webpack_public_path__ + "static/media/slider2.1b4606bb.jpg";